/**
 * Resolve a tour spotlight target by its `data-tour` id.
 */
export const queryTourTarget = (tourId: string): HTMLElement | null => {
  return document.querySelector(`[data-tour='${tourId}']`);
};
